"use strict";

var _regeneratorRuntime = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Account = void 0;

var lisk_codec_1 = require("@liskhq/lisk-codec");

var Account = /*#__PURE__*/function () {
  function Account(channel, schemas) {
    _classCallCheck(this, Account);

    this._channel = channel;
    this._schemas = schemas;
  }

  _createClass(Account, [{
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(address) {
        var addressString, accountHex;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                addressString = Buffer.isBuffer(address) ? address.toString('hex') : address;
                _context.next = 3;
                return this._channel.invoke('app:getAccount', {
                  address: addressString
                });

              case 3:
                accountHex = _context.sent;
                return _context.abrupt("return", this.decode(Buffer.from(accountHex, 'hex')));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function get(_x) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "encode",
    value: function encode(input) {
      return lisk_codec_1.codec.encode(this._schemas.account, input);
    }
  }, {
    key: "decode",
    value: function decode(input) {
      var inputBuffer = Buffer.isBuffer(input) ? input : Buffer.from(input, 'hex');
      return lisk_codec_1.codec.decode(this._schemas.account, inputBuffer);
    }
  }, {
    key: "toJSON",
    value: function toJSON(account) {
      return lisk_codec_1.codec.toJSON(this._schemas.account, account);
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(account) {
      return lisk_codec_1.codec.fromJSON(this._schemas.account, account);
    }
  }]);

  return Account;
}();

exports.Account = Account;